import DOMPurify from "dompurify";

// Allowlist config for stored template HTML. Mirrors the backend bleach
// allowlist so what the server accepts is what the client renders.
const ALLOWED_TAGS = [
    "table", "tbody", "thead", "tfoot", "tr", "td", "th",
    "p", "br", "strong", "b", "em", "i", "u", "s",
    "a", "h1", "h2", "h3", "ul", "ol", "li", "span", "div", "img",
];

const ALLOWED_ATTR = [
    "style", "href", "src", "alt", "width", "height",
    "cellpadding", "cellspacing", "border", "align", "valign",
    "target", "rel", "role", "colspan", "rowspan",
];

// Only http/https/mailto URLs are allowed. `javascript:` and `data:` schemes
// are stripped by DOMPurify when they hit ALLOWED_URI_REGEXP.
const ALLOWED_URI_REGEXP =
    /^(?:(?:https?|mailto):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i;

/** Sanitise a template body HTML string before dangerouslySetInnerHTML. */
export function sanitizeBodyHtml(html) {
    if (!html) return "";
    return DOMPurify.sanitize(html, {
        ALLOWED_TAGS,
        ALLOWED_ATTR,
        ALLOWED_URI_REGEXP,
        FORBID_TAGS: ["script", "style", "iframe", "object", "embed", "form", "input", "textarea", "link", "meta"],
        // Disallow on* handlers explicitly (DOMPurify already does this, but
        // this is a belt-and-braces guard).
        FORBID_ATTR: [
            "onerror", "onload", "onclick", "onmouseover", "onmouseout",
            "onfocus", "onblur", "onchange", "onsubmit", "onreset",
            "onkeydown", "onkeyup", "onkeypress",
        ],
    });
}

/** Sanitise a subject line — strip ALL tags, return plain text. */
export function sanitizeSubjectText(subject) {
    if (!subject) return "";
    return DOMPurify.sanitize(subject, {
        ALLOWED_TAGS: [],
        ALLOWED_ATTR: [],
        KEEP_CONTENT: true,
    }).trim();
}
